module.exports = __webpack_public_path__ + "TB_Powerdown_Ambience_B.wav.9f380771.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_down/TB_Powerdown_Ambience_B.wav.mp3
// module id = 497
// module chunks = 0